import { Component, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponentBase } from '../../../../../shared/common/app-component-base';
import { AddAwayTimeGetAllDto, AllDashboardServiceProxy, CompanyProfileServiceProxy } from '../../../../../shared/service-proxies/service-proxies';
import { UsersDateFormatService } from '@shared/common/dateTimeFormat/date-format.service';
import { AppConsts } from '@shared/AppConsts';

@Component({
  selector: 'app-leave-request',
  templateUrl: './leave-request.component.html',
  styleUrls: ['./leave-request.component.css']
})
export class LeaveRequestComponent extends AppComponentBase implements OnInit {
    userLeaveData: AddAwayTimeGetAllDto[];
    isLoaded = false;
    isEmpty = true;
    UserId: any;
    TenantId: any;
    istrueValue: boolean;
    constructor(private _AllDashboardServiceProxy: AllDashboardServiceProxy,private _usersDateFormatService: UsersDateFormatService,
        private _companyProfileServiceProxy: CompanyProfileServiceProxy, private router: Router, injector: Injector) { super(injector);}

    ngOnInit(): void {
        this.getUserLeavedetails();
        this.UserId = abp.session.userId;
        this.TenantId = abp.session.tenantId;
        this.getDateFormat();

    }

    getUserLeavedetails() {
        this.istrueValue = this.isGranted('Pages.ShowManager.Dashboard');
        this._AllDashboardServiceProxy.getLeaveRequest(this.istrueValue).subscribe(result => {
            //console.log(result);
            this.userLeaveData = [];
            result.forEach(x => {
                if (x.userImage === '' || x.userImage === 'undefined' || x.userImage === null) {
                    x.userImage = 'assets/common/images/default-profile-picture1.svg';
                }
                this.userLeaveData.push(x);
                this.isEmpty = false;
            });
            this.isLoaded = true;
            result.forEach(x=>{
                x.userRole = x.userRole.map(x=>this.l(x));
            })
        });

    }

    viewall(){
        this.router.navigate(['/app/main/Leaves/overview'], { queryParams: { 'redirectTo':'approvals' }});
    }


    DisableTooltip(name: string, num: number) {
        return name?.length > num ? false : true;
    }

    //to bind the date format as selected in company profile
    dateId: number;
    dateFormat = 'dd/MM/yyyy';
    getDateFormat() {
        if (AppConsts.dateFormatId !== undefined) {
            this.dateId = AppConsts.dateFormatId;
            this.dateFormat = this._usersDateFormatService.findUsersDateFormat(this.dateId);
        }
    }

}
